var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm._l(_vm.billInfo.payments, function(payment, indexPayment) {
        return _c(
          "div",
          {
            key: `payment-account-number-${indexPayment}`,
            staticClass: "bg-secondary-13 p-3 rounded mt-5"
          },
          [
            _c("div", [
              _c("div", { staticClass: "row" }, [
                _c(
                  "div",
                  { staticClass: "col" },
                  [
                    _c("icon-view", {
                      attrs: {
                        icon: "fa fa-usd-square",
                        "icon-background": "#2DB782",
                        "icon-color": "#fff",
                        title: "Pago"
                      }
                    })
                  ],
                  1
                ),
                _c("div", { staticClass: "col text-center" }, [
                  _c(
                    "div",
                    { staticClass: "color-black font-16 font-weight-bold" },
                    [_vm._v(" " + _vm._s(payment.paymentNumber) + " ")]
                  )
                ]),
                _c("div", { staticClass: "col d-flex justify-content-end" }, [
                  _c("div", { staticClass: "d-flex" }, [
                    _c("span", [_vm._v("Monto Total:")]),
                    _c(
                      "span",
                      { staticClass: "color-black font-weight-bold ml-2" },
                      [
                        _vm._v(
                          " " +
                            _vm._s(_vm._f("price")(payment.purchaseTotal)) +
                            " "
                        )
                      ]
                    )
                  ])
                ]),
                _c(
                  "div",
                  {
                    staticClass:
                      "col-auto d-flex align-items-end justify-content-end"
                  },
                  [
                    _vm.cantPrintDistributionNumber(payment)
                      ? _c(
                          "action-button",
                          {
                            attrs: { i: "fas fa-print", variant: "success" },
                            on: {
                              click: function($event) {
                                return _vm.$emit(
                                  "print-payment-distribution",
                                  payment.paymentId
                                )
                              }
                            }
                          },
                          [_vm._v(" Imprimir Distribución de Pago ")]
                        )
                      : _vm._e()
                  ],
                  1
                ),
                _c(
                  "div",
                  {
                    staticClass:
                      "col-1 d-flex align-items-end justify-content-end"
                  },
                  [
                    _vm.showUpdateVoucherStatus &&
                    payment.voucherNumber &&
                    (!payment.voucherTrackingInfo ||
                      !payment.voucherTrackingInfo.cashClearedDate)
                      ? _c("action-button", {
                          staticClass:
                            "py-1 px-0 pl-2 d-flex justify-content-center align-items-center",
                          attrs: {
                            i: "fas fa-redo-alt pr-2 pt-1",
                            variant: "outline-success"
                          },
                          on: {
                            click: function($event) {
                              return _vm.$emit(
                                "on-update-voucher-status",
                                payment.voucherNumber
                              )
                            }
                          }
                        })
                      : _vm._e()
                  ],
                  1
                )
              ]),
              _c("div", { staticClass: "row" }, [
                _c(
                  "div",
                  { staticClass: "col ml-2 mt-2" },
                  [
                    _c(
                      "span",
                      {
                        staticClass:
                          "color-gray-6 font-16 font-weight-normal mr-2"
                      },
                      [_vm._v(" PO ID: ")]
                    ),
                    _vm.showChoosePO(payment)
                      ? _c("custom-drop-down", {
                          staticClass: "w-50",
                          attrs: {
                            clearable: false,
                            fieldkey: "id",
                            fieldname: "name",
                            options: _vm.purchaseOrders,
                            placeholder: "Seleccione"
                          },
                          on: { input: _vm.onChangePurchaseOrderHandler },
                          model: {
                            value: _vm.value.purchaseOrderId,
                            callback: function($$v) {
                              _vm.$set(_vm.value, "purchaseOrderId", $$v)
                            },
                            expression: "value.purchaseOrderId"
                          }
                        })
                      : _c(
                          "span",
                          {
                            staticClass:
                              "color-black font-16 font-weight-normal"
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  `${payment.purchaseOrderId} (${payment.purchaseOrderBudgetYear})`
                                ) +
                                " "
                            )
                          ]
                        )
                  ],
                  1
                ),
                _c(
                  "div",
                  {
                    staticClass:
                      "col d-flex align-items-center justify-content-center"
                  },
                  [
                    _c(
                      "span",
                      {
                        staticClass:
                          "color-gray-6 font-16 font-weight-normal mr-2"
                      },
                      [_vm._v(" Voucher ID: ")]
                    ),
                    _c(
                      "span",
                      { staticClass: "color-black font-16 font-weight-normal" },
                      [
                        _vm._v(
                          " " +
                            _vm._s(_vm._f("empty")(payment.voucherNumber)) +
                            " "
                        )
                      ]
                    )
                  ]
                ),
                _c(
                  "div",
                  {
                    staticClass:
                      "col d-flex justify-content-end align-items-center"
                  },
                  [
                    _c(
                      "span",
                      {
                        staticClass:
                          "color-gray-6 font-16 font-weight-normal mr-2"
                      },
                      [_vm._v(" Entry Status: ")]
                    ),
                    _c(
                      "span",
                      { staticClass: "color-black font-16 font-weight-normal" },
                      [
                        _vm._v(
                          " " +
                            _vm._s(_vm._f("empty")(payment.voucherStatus)) +
                            " "
                        )
                      ]
                    )
                  ]
                ),
                _c("div", { staticClass: "col-md-1" })
              ])
            ]),
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                { staticClass: "col-md-12" },
                [
                  payment.voucherTrackingInfo &&
                  payment.voucherTrackingInfo.voucherStatusReason
                    ? _c("error", {
                        staticStyle: { border: "none" },
                        attrs: {
                          message:
                            "<b>Razón de Cancelación: </b>" +
                            payment.voucherTrackingInfo.voucherStatusReason,
                          variant: "custom-error-extended"
                        }
                      })
                    : _vm._e()
                ],
                1
              )
            ]),
            _c("hr"),
            _vm._l(payment.billingPurchaseOrderNumbers, function(item, index) {
              return _c(
                "div",
                {
                  key: `account-number-${index}`,
                  staticClass: "row bg-white m-1 rounded p-3 mb-2"
                },
                [
                  _c("div", { staticClass: "col-md-4 mt-1" }, [
                    _c("div", { staticClass: "color-secondary-6 font-14" }, [
                      _vm._v(" Número de Cifra: ")
                    ]),
                    _c("div", { staticClass: "color-black font-16" }, [
                      _vm._v(" " + _vm._s(item.fullNumber) + " ")
                    ])
                  ]),
                  _c("div", { staticClass: "col-sm mt-1" }, [
                    _c("div", { staticClass: "color-secondary-6 font-14" }, [
                      _vm._v(" Número de línea: ")
                    ]),
                    _c("div", { staticClass: "color-black font-16" }, [
                      _vm._v(" " + _vm._s(item.lineNumber) + " ")
                    ])
                  ]),
                  _c("div", { staticClass: "col-sm mt-1" }, [
                    _c("div", { staticClass: "color-secondary-6 font-14" }, [
                      _vm._v(" Tipo de Cifra: ")
                    ]),
                    _c("div", { staticClass: "color-black font-16" }, [
                      _vm._v(" " + _vm._s(item.digitType) + " ")
                    ])
                  ]),
                  _c("div", { staticClass: "col-sm mt-1" }, [
                    _c("div", { staticClass: "color-secondary-6 font-14" }, [
                      _vm._v(" Grupo de edad: ")
                    ]),
                    _c("div", { staticClass: "color-black font-16" }, [
                      _vm._v(" " + _vm._s(item.ageRange) + " ")
                    ])
                  ]),
                  _c("div", { staticClass: "col-sm mt-3 mt-md-1 mt-sm-3" }, [
                    _c("div", { staticClass: "color-secondary-6 font-14" }, [
                      _vm._v(" Monto: ")
                    ]),
                    _c("div", { staticClass: "color-black font-16 font-14" }, [
                      _vm._v(" " + _vm._s(_vm._f("price")(item.amount)) + " ")
                    ])
                  ]),
                  !payment.voucherNumber
                    ? _c(
                        "div",
                        { staticClass: "col-sm mt-1 mr-3 mr-md-0 mr-sm-3" },
                        [
                          _c(
                            "action-button",
                            {
                              attrs: {
                                i: "fas fa-times-circle",
                                variant:
                                  "outline-danger btn-cancel danger m-2 pr-4"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.deleteBillingDigit(item)
                                }
                              }
                            },
                            [_vm._v(" Eliminar ")]
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ]
              )
            }),
            _vm.showBillPaymentForm(payment)
              ? _c(
                  "validation-observer",
                  {
                    ref: "billPaymentForm",
                    refInFor: true,
                    attrs: { novalidate: "", tag: "form" }
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "row bg-white mt-3 rounded p-2 mx-1" },
                      [
                        _c(
                          "div",
                          { staticClass: "col-md-4" },
                          [
                            _c(
                              "div",
                              { staticClass: "color-secondary-4 font-14" },
                              [_vm._v(" Número de Cifra: ")]
                            ),
                            _c("validation-provider", {
                              attrs: { rules: "required" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function({ errors }) {
                                      return [
                                        _c("custom-drop-down", {
                                          staticClass: "w-75",
                                          attrs: {
                                            clearable: false,
                                            "custom-error-msg":
                                              "Favor seleccionar al menos una cifra de cuenta.",
                                            error: errors[0],
                                            fieldkey: "id",
                                            fieldname: "name",
                                            options: _vm.paymentDigitList(
                                              payment
                                            ),
                                            placeholder: "Seleccione"
                                          },
                                          on: {
                                            input: _vm.onPurchaseOrderChange
                                          },
                                          model: {
                                            value:
                                              _vm.value.purchaseOrderNumber,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.value,
                                                "purchaseOrderNumber",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "value.purchaseOrderNumber"
                                          }
                                        })
                                      ]
                                    }
                                  }
                                ],
                                null,
                                true
                              )
                            })
                          ],
                          1
                        ),
                        _c("div", { staticClass: "col-sm mt-1 pl-5" }, [
                          _c(
                            "div",
                            { staticClass: "color-secondary-6 font-14" },
                            [_vm._v(" Número de línea: ")]
                          ),
                          _c("div", { staticClass: "color-black font-16" }, [
                            _vm._v(" " + _vm._s(_vm.lineNumber) + " ")
                          ])
                        ]),
                        _c("div", { staticClass: "col-sm mt-1 pl-5" }, [
                          _c(
                            "div",
                            { staticClass: "color-secondary-6 font-14" },
                            [_vm._v(" Tipo de Cifra: ")]
                          ),
                          _c("div", { staticClass: "color-black font-16" }, [
                            _vm._v(" " + _vm._s(_vm.digitType) + " ")
                          ])
                        ]),
                        _c("div", { staticClass: "col-sm mt-1 pl-5" }, [
                          _c(
                            "div",
                            { staticClass: "color-secondary-6 font-14" },
                            [_vm._v(" Grupo de Edad: ")]
                          ),
                          _c("div", { staticClass: "color-black font-16" }, [
                            _vm._v(
                              " " + _vm._s(_vm.billingServiceCategoryName) + " "
                            )
                          ])
                        ]),
                        _c(
                          "div",
                          { staticClass: "col-sm mt-3 mt-md-1 mt-sm-3" },
                          [
                            _c(
                              "div",
                              { staticClass: "color-secondary-6 font-14" },
                              [_vm._v(" Balance: ")]
                            ),
                            _c(
                              "div",
                              { staticClass: "color-secondary-6font-14" },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm._f("price")(_vm.balance)) +
                                    " "
                                )
                              ]
                            )
                          ]
                        ),
                        _c(
                          "div",
                          { staticClass: "col-sm mt-3 mr-4 mt-md-1 mt-sm-3" },
                          [
                            _c(
                              "div",
                              { staticClass: "color-secondary-6 font-14" },
                              [_vm._v(" Monto: ")]
                            ),
                            _c("validation-provider", {
                              attrs: { rules: "required" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function({ errors }) {
                                      return [
                                        _c(
                                          "div",
                                          { staticClass: "input-group mb-3" },
                                          [
                                            _c("custom-input", {
                                              staticClass:
                                                "custom-input__extended w-100",
                                              attrs: {
                                                "custom-error-msg":
                                                  "Campo Requerido",
                                                error: errors[0],
                                                "mask-type": "Money",
                                                "prepend-icon":
                                                  "fa fa-dollar-sign",
                                                "prepend-icon-left": true,
                                                "prepend-icon-type": "success"
                                              },
                                              model: {
                                                value: _vm.value.amount,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.value,
                                                    "amount",
                                                    $$v
                                                  )
                                                },
                                                expression: "value.amount"
                                              }
                                            }),
                                            errors[0]
                                              ? _c("error", {
                                                  attrs: {
                                                    message:
                                                      "Favor de entrar el monto. (0326).",
                                                    variant: "no-border"
                                                  }
                                                })
                                              : _vm._e()
                                          ],
                                          1
                                        )
                                      ]
                                    }
                                  }
                                ],
                                null,
                                true
                              )
                            })
                          ],
                          1
                        ),
                        _c(
                          "div",
                          {
                            staticClass:
                              "col-md-12 mt-1 d-flex align-items-center justify-content-end"
                          },
                          [
                            _c(
                              "action-button",
                              {
                                attrs: {
                                  i: "fas fa-times-circle",
                                  variant: "outline-danger btn-cancel danger"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.cancelBillingDigit()
                                  }
                                }
                              },
                              [_vm._v(" Cancelar ")]
                            ),
                            _c(
                              "action-button",
                              {
                                attrs: {
                                  i: "fas fa-save",
                                  variant: "success m-2 pl-4 pr-4"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.saveBillingDigit(payment)
                                  }
                                }
                              },
                              [_vm._v(" Guardar ")]
                            )
                          ],
                          1
                        )
                      ]
                    )
                  ]
                )
              : _vm._e(),
            _c("div", { staticClass: "row ml-2 mt-3" }, [
              _vm.showProof(payment)
                ? _c(
                    "div",
                    { staticClass: "col-md-3 d-flex align-items-center" },
                    [
                      _c(
                        "span",
                        { staticClass: "color-secondary-6 font-14 mr-2" },
                        [_vm._v(" Número de Voucher: ")]
                      ),
                      _c("span", { staticClass: "color-black font-16" }, [
                        _vm._v(" " + _vm._s(payment.voucherNumber) + " ")
                      ])
                    ]
                  )
                : _vm._e(),
              _vm.showProof(payment)
                ? _c(
                    "div",
                    { staticClass: "col-md-3 d-flex align-items-center" },
                    [
                      _c(
                        "span",
                        { staticClass: "color-secondary-6 font-14 mr-2" },
                        [_vm._v(" Número de Cheque: ")]
                      ),
                      _c("span", { staticClass: "color-black font-16" }, [
                        _vm._v(" " + _vm._s(payment.paymentIdReference) + " ")
                      ])
                    ]
                  )
                : _vm._e(),
              !_vm.isPayment(payment) && !payment.voucherNumber
                ? _c(
                    "div",
                    {
                      class:
                        _vm.isPayment(payment) && !payment.voucherNumber
                          ? "col-md-6 text-right mt-1"
                          : "col-md-12 text-right mt-1"
                    },
                    [
                      _c(
                        "action-button",
                        {
                          attrs: {
                            i: "fas fa-times-circle",
                            variant: "outline-danger btn-cancel danger mt-3"
                          },
                          on: {
                            click: function($event) {
                              return _vm.cancelPayment(payment)
                            }
                          }
                        },
                        [_vm._v(" Cancelar Pago ")]
                      ),
                      _c(
                        "action-button",
                        {
                          attrs: {
                            i: "fas fa-file-plus",
                            variant: "outline-success m-2 pl-3 pr-3"
                          },
                          on: {
                            click: function($event) {
                              return _vm.addPayment(payment)
                            }
                          }
                        },
                        [_vm._v(" Añadir Cifra ")]
                      )
                    ],
                    1
                  )
                : _vm._e()
            ]),
            _vm.showTrackingInfo(payment)
              ? _c(
                  "div",
                  { staticClass: "mt-4 bg-gray-9 rounded p-3" },
                  [
                    _c("voucher-and-payment-status-info", {
                      attrs: { info: payment.voucherTrackingInfo }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm._t("documents", null, null, { payment })
          ],
          2
        )
      }),
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col d-flex justify-content-end mt-3" },
          [
            _vm.canAddVoucher
              ? _c("action-button", {
                  attrs: {
                    i: "fas fa-file-plus",
                    text: "Añadir Voucher",
                    variant: "success"
                  },
                  on: { click: _vm.addPayment }
                })
              : _vm._e()
          ],
          1
        )
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }